// Utility pure estratte da Menu.js

const isDemo = process.env.REACT_APP_IS_DEMO === 'true';

// Controlla se la data più recente è passata da almeno 4 ore rispetto al momento presente
export function checkIfAllDatesAreExpired(arrayOfDates) {
  if (isDemo) return false;
  return arrayOfDates.every((date) => date.valueOf() + 4 * 3600 * 1000 < Date.now());
}

export function formatDate(date) {
  if (!date) return '';
  const options = { weekday: 'long', month: 'short', day: 'numeric' };
  return new Intl.DateTimeFormat('it', options).format(new Date(date));
}

export function formatDateWithTime(date) {
  if (!date) return '';
  const options = {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };
  return new Intl.DateTimeFormat('it', options).format(new Date(date));
}

export function pranzoCena(date) {
  return new Date(date).getHours() < 16 ? 'pranzo' : 'cena';
}

// Restituisce { text, color } per la disponibilità di un prodotto
export function getAvailabilityTextAndColor(qtyForDate/*, category*/) {
  const currentAvailability = parseInt(qtyForDate);
  let text =
    currentAvailability > 10
      ? 'Disponibilità alta'
      : currentAvailability <= 0
      ? 'Prodotto esaurito'
      // : 'Disponibilità ' + currentAvailability;
      : 'Disponibilità limitata';

  let color =
    text === 'Disponibilità alta' ? 'white' : text === 'Prodotto esaurito' ? 'tomato' : 'orange';

  // Rimosso perche' se no comparae al cashier limitata
  // if (category === 'gourmet') {
  //   text = 'Disponibilità limitata';
  //   color = 'tomato';
  // }
  return { text, color };
} 